<template>
  <div class="payment-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "paymentBase",
};
</script>
